import { Component, OnInit, OnDestroy } from '@angular/core';
import { WellData, FieldData } from '../../../../app/_models/field';
import { PortalApiService } from '../../../../app/_services/portal-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserProfileService } from '../../../_services/user-profile.service';
import { Subject, takeUntil } from 'rxjs';
import { UserProfile } from '../../../_models/user-profile';

@Component({
  selector: 'app-well-select',
  templateUrl: './well-select.component.html',
  styleUrls: ['./well-select.component.css']
})
export class WellSelectComponent implements OnInit, OnDestroy {
  userProfile: UserProfile;
  hasWellFilesAccess: boolean = true;
  selectedWellID: any = null;
  selectedWell: WellData;
  fieldListWithWells: FieldData[];
  wellsList: WellData[];
  wellOptions: any[] = [];
  isLoadingWellList: boolean;
  errorWellList: string = null;
  errorSelectedWell: string;
  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private userService: UserProfileService,
    private apiService: PortalApiService,
    private route: ActivatedRoute,
    private router: Router
  ) {

    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(
      userProfile => {
        this.userProfile = userProfile;
        this.checkForWellFilesPermission();
      });
  }

  ngOnInit(): void {
    this.getFieldAndWellList();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  checkForWellFilesPermission() {
    if (this.userProfile.permissions.includes('WELLFILES') || this.userProfile.isSuperAdmin) {
      this.hasWellFilesAccess = true;
    }
    else {
      this.hasWellFilesAccess = false;
    }
  }

  getFieldAndWellList() {
    this.errorWellList = null;
    this.fieldListWithWells = [];
    this.wellsList = [];
    this.isLoadingWellList = true;
    this.apiService.getFieldList(true).subscribe({
      next: (data: FieldData[]) => {
        let lstWellOptions: any[] = [];
        this.fieldListWithWells = data;
        for (var i = 0; i < this.fieldListWithWells.length; i++) {
          for (var j = 0; j < this.fieldListWithWells[i].wells.length; j++) {
            let wellLabel: string = this.fieldListWithWells[i].wells[j].wellName + ' - API#' + this.fieldListWithWells[i].wells[j].apiNumber;
            let newSelectOption: any = {
              wellName: this.fieldListWithWells[i].wells[j].wellName,
              apiNumber: this.fieldListWithWells[i].wells[j].apiNumber,
              label: wellLabel,
              value: this.fieldListWithWells[i].wells[j].wellID
            }
            this.wellsList.push(this.fieldListWithWells[i].wells[j]);
            lstWellOptions.push(newSelectOption);
          }
        }

        this.wellOptions = lstWellOptions;
        this.isLoadingWellList = false;
      },
      error: err => {
        console.log(err);
        this.errorWellList = (err.error || 'An error occurred while retrieving the well list.');
        this.isLoadingWellList = false;
      }
    })
  }

  onWellSelect(value: any) {
    this.selectedWellChanged();
  }

  selectedWellChanged() {
    let foundWell: WellData = this.wellsList.find(well => well.wellID == this.selectedWellID);
    if (foundWell && foundWell != null) {
      this.selectedWell = foundWell;
      this.router.navigate(['../wellfiles/' + this.selectedWellID], { relativeTo: this.route });
      // SAVE FIELD AND WELL LIST IN SERVICE
    }
    else {
      this.selectedWellID = null;
      this.selectedWell = null;
      this.errorSelectedWell = 'An error occurred. The requested well could not be found.';
    }
  }
}
